import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ConferencePageComponent} from './conference/conference.page';
import {TestComponent} from './test/test.component';
import {ConferenceResultsPageComponent} from './results/results.page';

const routes: Routes = [
    {
        path: '',
        component: ConferencePageComponent
    },
    {
        path: 'test',
        component: TestComponent
    },
    {
        path: ':task_id',
        component: ConferencePageComponent
    },
    {
        path: ':task_id/results',
        component: ConferenceResultsPageComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ConferenceRoutingModule {
}
